var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgProvinsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 42,
    viewBox: "0 0 28 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6428 40.0256L15.6308 40.0456L15.6198 40.0661C15.3855 40.5054 14.9013 40.7919 14.3603 40.7919H14.3105H14.2608C13.7513 40.7919 13.2837 40.5299 12.9833 40.0339C11.713 37.817 8.89888 32.7948 6.40336 27.5251C5.15369 24.8862 3.99079 22.1996 3.1421 19.7807C2.28512 17.3383 1.78057 15.256 1.78057 13.7932C1.78057 6.62427 7.14627 1.71222 13.8615 1.71222H14.3606H14.8597H14.8602C21.5254 1.71222 26.9412 6.62455 26.9412 13.8431C26.9412 15.3057 26.4366 17.388 25.5782 19.8292C24.728 22.2469 23.5621 24.9316 22.3065 27.5667C19.7953 32.8366 16.9533 37.85 15.6428 40.0256ZM7.18373 14.0428C7.18378 18.0318 10.4309 21.2199 14.3609 21.2199C18.286 21.2199 21.5382 18.0364 21.5382 14.0925C21.5382 10.1035 18.291 6.91532 14.3609 6.91532C10.4356 6.91532 7.18338 10.0988 7.18373 14.0427V14.0428Z",
    stroke: "#333333",
    strokeWidth: 1.78185
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvinsi);
export default __webpack_public_path__ + "static/media/provinsi.8a1263ab2039211329c041ff1da8d43d.svg";
export { ForwardRef as ReactComponent };